export default {
  getCreditSectorOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.isCreditSectorOptionOn;
  },
  getBankingSectorOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.isBankingSectorOptionOn;
  },
  getAutomativeSectorOptionBoxFlagGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.isAutomativeOptionOn;
  },
  getSectorDropdownDataAPI(state) {
    return state.rawSectorAutomativeData;
  },
  getSubCategoryGetters(state) {
    return state.subCategorySectorData;
  },
  getCategorySelectedGetters(state) {
    return state.CategorySelected;
  },
  getSubCategorySelectedGetters(state) {
    return state.subCategorySelected;
  },
  getsubSubCategorySelectedGetters(state) {
    return state.subSubCategorySelected;
  },
  getCreditComboBoxesGetters(state) {
    return state.CreditComboBoxes;
  },
  getSubSubCategoryGetters(state) {
    return state.subSubCategorySectorData;
  },
  getcategorySector(state) {
    return state.categorySectorData;
  },
  getcategoryFieldsCleaningGetter(state) {
    return state.categoryFieldsCleaning;
  },
  getProductNameGetters(state) {
    return state.productName;
  },
  getBankingCardGetters(state) {
    return state.BankingCard;
  },
  getenergyBoxesFlag(state) {
    return state.energyBoxesFlag;
  },
  getSectorEDCEnergyData(state) {
    return state.SectorEDCEnergyData;
  },
  getsectorIdComm(state) {
    return state.sectorIdComm;
  },
  getSectorCommData(state) {
    return state.SectorCommData;
  },
  getAllSectorsIds(state) {
    return state.sectorAllIds;
  },
  getMortageSelectedGett(state) {
    return state.mortgageSelectedFlag;
  },
  getresponseMechanismGett(state) {
    return state.responseMechanism;
  },
  getresponseMechanismAPIGett(state) {
    return state.responseMechanismAPI;
  },
  getrangeSliderGett(state) {
    return state.rangeSlider;
  },
  getInsuranceBoxFlagGetters(state) {
    return state.insuranceBoxFlag;
  },
  getInvestmentBoxFlagGetters(state) {
    return state.investmentBoxFlag;
  },
  getTravelRetailBoxFlagGetters(state) {
    return state.retailTravelFlag;
  },
  getsectorIdRiders(state) {
    return state.sectorIdRidersData;
  },
  getsectorFaceAmtDataGett(state) {
    return state.sectorFaceAmtData;
  },
  getIssueTypeDataGett(state) {
    return state.sectorIssueTypeData;
  },
  getCheckboxPayload(state) {
    return state.checkboxPayload;
  },
  getCheckboxPayloadtargetIds(state) {
    return state.targetIds;
  },
  getAncillaryProducts(state) {
    return state.ancillary_products;
  },
  getResponseMechanismId(state) {
    return state.response_mechanism_id;
  },
  getCampaignLanguage(state) {
    return state.campaign_language;
  },
  getCardNetwork(state) {
    return state.card_network;
  },
  getDeliveryMethodId(state) {
    return state.delivery_method_id;
  },
  getDeliveryTypeId(state) {
    return state.delivery_type_id;
  },
  getPackageTypeId(state) {
    return state.package_type_id;
  },
  getPresortedId(state) {
    return state.presorted_id;
  },
  getPostageId(state) {
    return state.postage_id;
  },
  getEnergySetPayload(state) {
    return state.energySelPayload;
  },
  getSiDropDownPayload(state) {
    return state.siDropDownPayload;
  },
  getcategoryPayload(state) {
    return state.categoryPayload;
  },
  getsubcategoryPayload(state) {
    return state.subcategoryPayload;
  },
  getOfferOrigin(state) {
    return state.sectorIdOfferOriginData;
  },
  getLoanAmount(state) {
    return state.loanAmount;
  },
  getAffinityCategories(state) {
    return state.affinityCategory;
  },
  getEnergyRateType(state) {
    return state.dropDownData.energyRateType;
  },
  getdropDownDataDma(state) {
    return state.dropDownData.dma;
  },
  getdropDownDataCscanEdc(state) {
    return state.dropDownData.cscanEdc;
  },
  getdropDownDataIncomeProducing(state) {
    return state.dropDownData.incomeProducing;
  },
  getdropDownDataScoreHousehold(state) {
    return state.dropDownData.scoreHousehold;
  },
  getdropDownDataEtermLength(state) {
    return state.dropDownData.etermLength;
  },
  getDefaultDropDownData(state) {
    return state.defaultDropDownData;
  },
  getTermLength(state) {
    return state.termLenghtData;
  },
  getBankCreditGetters(state) {
    return state.setBankCreditAction;
  },
  getAllSectorsGetters(state) {
    return state.allSectors;
  },
  getAllCategoryLocalGetters(state) {
    return state.allSectorsLocal;
  },
  getAllSubCategoryLocalGetters(state) {
    return state.allSubSectorsLocal;
  },
  getAllSubSubCategoryLocalGetters(state) {
    return state.allSubSubSectorsLocal;
  },
  getSelectAllFlagGetters(state) {
    return state.selectAllFlag;
  },
  getselectedDataGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.selectedData;
  },
  getLastSearchActivatedGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.iSLastSearchFlag;
  },
  getcategoriesParentsGetters(state) {
    // console.log(state.socialNetworkNameBoxFlag, 90);
    return state.categoriesParents;
  },
};
